export default function List ({caption = "", children}) {
    return [
        caption && <p className="precaption" key="list_block_0">{caption}</p>,
        <ul key="list_block_1">
            {children}
        </ul>
    ];
};